//@ts-check
import React from 'react';

var FilePreviewFrame = function FilePreviewFrame(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      textAlign: 'center'
    }
  }, React.createElement("div", {
    style: {
      border: '1px solid darkgrey',
      background: 'white',
      display: 'inline-block'
    }
  }, children));
};

export default FilePreviewFrame;